import Vue from 'vue';
import Vuex from 'vuex';
import bounty from './modules/bounty.js';
import app from './modules/app.js';
import advert from './modules/advert.js';
import core from './modules/core.js';

Vue.use(Vuex);

// function createStore() {
//   return
// }
const store = new Vuex.Store({
  strict: true,
  modules: {
    bounty,
    advert,
    core,
    app
  }
});
export default store;
